// extracted by mini-css-extract-plugin
export default {"background":"apo4KJ","external":"bpo4KJ","imgGap":"cpo4KJ"};